import * as React from 'react';
export function cloneElement(element, ...restArgs) {
    if (!React.isValidElement(element))
        return element;
    return React.cloneElement(element, ...restArgs);
}
